import React, { useContext } from 'react';
import ContextDemanda from '@app/hooks/useQuestionario';
import { getLoggedId } from '@app/helpers';
import { aprovarDemanda, DadosAbaSumario, Demanda } from '@app/api/demanda';
import ModalCancelarDemandaFaturamentoDireto from '../dadosGerais/ModalCancelarDemandaFaturamentoDireto';
import Button from '@digital/ui/lib/components/Button';

interface Props {
  demanda: Demanda;
  sumarioData: DadosAbaSumario | undefined;
}

const FooterAbaSumarioFaturamentoDireto = ({ demanda, sumarioData }: Props) => {
  const { setUpdate, update } = useContext(ContextDemanda);

  const onUpdate = () => {
    setUpdate(!update);
  };

  const handleAprovar = () => {
    if (sumarioData) {
      aprovarDemanda(sumarioData.id).then( (data:any) => {
        if (data.valid) {
          onUpdate();
        }
      });
    }
  };


  return (
  <div className="ant-app-form-actions">
    {sumarioData && sumarioData.validarDemanda && demanda && demanda.statusCodigo &&
      (demanda.statusCodigo == 26 || demanda.statusCodigo == 27) && (
      <>
        <Button type="success" onClick={handleAprovar}>
          APROVAR
        </Button>
        <ModalCancelarDemandaFaturamentoDireto onUpdate={onUpdate} />
      </>
    )}
  </div>
);
};

export default FooterAbaSumarioFaturamentoDireto;
